import { useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import store2 from "store2";
import { format } from "date-fns";
import { useUser } from "../../api/useAuth";
import { endSession } from "../../api/session";
import { MENU_WIDTH } from "../menu/Menu";

export const ImpersonationBanner = () => {
    const { data: user } = useUser();
    const storedAuth = store2.get("auth");
    const impersonationEndsAt: number | null = storedAuth?.impersonation ? storedAuth.expires_at : null;

    useEffect(() => {
        if (!impersonationEndsAt) {
            return;
        }
        const millisecondsUntilEnd = Math.max(impersonationEndsAt - Date.now(), 0);
        const endTimer = window.setTimeout(() => endSession("/login"), millisecondsUntilEnd);
        const clearEndTimer = () => window.clearTimeout(endTimer);
        return clearEndTimer;
    }, [impersonationEndsAt]);

    if (!impersonationEndsAt) {
        return null;
    }

    const impersonatedName = `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim();
    const bannerText = `A ver como ${impersonatedName} · termina às ${format(impersonationEndsAt, "HH:mm")}`;

    return (
        <Box
            display="flex"
            alignItems="center"
            gap={1.5}
            sx={{ ml: { sm: `${MENU_WIDTH}px` }, bgcolor: "warning.main", color: "warning.contrastText", borderRadius: 1, px: 1.5, py: 0.5 }}
        >
            <Typography variant="body2" fontWeight="bold">
                {bannerText}
            </Typography>
            <Button size="small" variant="outlined" color="inherit" onClick={() => endSession("/login-impersonate")}>
                Terminar
            </Button>
        </Box>
    );
};
